import { get } from '@core/api/baseApi';
import { ResultResponse } from '@core/types';
import { ReferrersGroups } from '../types/referrerGroup';

const getReferrersGroups = (searchTerm: string) =>
  get<ResultResponse<ReferrersGroups[]>>('/ReferrerGroup', {
    params: { searchTerm },
  });

export default getReferrersGroups;
